<template>
  <div class="footer-box" v-if="!isAlibabaDistributor">
    <!--多快好省-->
    <div class="footer_describe" v-if="footerLogo">
      <div class="footer_describe_content">
        <div class="footer_describe_item" v-for="item in describeList" :key="item.describeTitle">
          <img :src="item.describeImg" :width="item.describeImgWidth" :height="item.describeImgHeight" alt="">
          <div class="describe_conter">
            <h3 class="describe_title">{{ item.describeTitle }}</h3>
            <p class="describe_txt">{{ item.describeTxt }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--底部信息-->
    <div class="footer-info-box" :class="footerTheme">
      <div class="footer-info-content">
        <div class="footer-nav">
          <div
            class="nav-item"
            v-for="section in navSections"
            :key="section.title">
            <p class="nav-item-title">{{ section.title }}</p>
            <p class="nav-item-menu" v-for="link in section.links" :key="link.label">
              <a :href="link.href" target="_blank" rel="noopener noreferrer">{{ link.label }}</a>
            </p>
          </div>
          <div class="nav-item" v-if="footerInfo">
            <p class="nav-item-title">FOLLOW US</p>
            <p class="flex flex-wrap width_125">
              <a
                v-for="item in followList"
                :key="item.alt"
                :href="item.href"
                target="_blank"
                rel="noopener noreferrer">
                <img class="mr12 mb6" :src="item.icon" :alt="item.alt">
              </a>
            </p>
          </div>
        </div>
        <div class="keep-on-record" v-if="footerInfo">
          <span>{{ footerInfo.systemBottomFiling }}</span>
          <a
            v-if="footerInfo.domainFilingCode"
            href="https://beian.miit.gov.cn"
            target="_blank"
            rel="noopener noreferrer">{{ $t('key1000052') + footerInfo.domainFilingCode }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import {getHrefPath, isAlibabaDistributor, commonLocalStorage} from '@/utils/common';

// 商城服务前缀，用于拼接底部页内跳转链接
const SHOPPING_SERVICE = '/yms-shopping-service';

// TRS 底部品牌卖点展示项
const DESCRIBE_LIST = [
  {
    describeImg: require('@/assets/images/trs/icon01.png'),
    describeImgWidth: '44',
    describeImgHeight: '44',
    describeTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000044'),
    describeTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000045')
  },
  {
    describeImg: require('@/assets/images/trs/icon02.png'),
    describeImgWidth: '44',
    describeImgHeight: '42',
    describeTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000046'),
    describeTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000047')
  },
  {
    describeImg: require('@/assets/images/trs/icon03.png'),
    describeImgWidth: '42',
    describeImgHeight: '44',
    describeTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000048'),
    describeTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000049')
  },
  {
    describeImg: require('@/assets/images/trs/icon04.png'),
    describeImgWidth: '44',
    describeImgHeight: '44',
    describeTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000050'),
    describeTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000051')
  }
];

// 社交媒体与联系方式图标链接
const FOLLOW_LIST = [
  {
    icon: require('@/assets/images/trs/footer_01.png'),
    href: 'https://www.linkedin.com/company/tarazon/posts/',
    alt: 'LinkedIn'
  },
  {
    icon: require('@/assets/images/trs/footer_02.png'),
    href: 'https://www.facebook.com/cncmotoparts',
    alt: 'Facebook'
  },
  {
    icon: require('@/assets/images/trs/footer_03.png'),
    href: 'https://www.youtube.com/@tarazon6646',
    alt: 'YouTube'
  },
  {
    icon: require('@/assets/images/trs/footer_04.png'),
    href: 'mailto:sales@tarazon.cn',
    alt: 'Email'
  },
  {
    icon: require('@/assets/images/trs/footer_05.png'),
    href: 'tel:+86-18261587952',
    alt: 'Phone'
  },
  {
    icon: require('@/assets/images/trs/footer_06.png'),
    href: 'https://api.whatsapp.com/send?phone=8618261587952',
    alt: 'WhatsApp'
  }
];

// 底部文字导航分组配置（title + 路由 path）
const FOOTER_NAV_CONFIG = [
  {
    title: 'CREAT ACCOUNT',
    links: [
      {label: 'SIGN UP', path: '/login.html#/register'},
      {label: 'SIGN IN', path: '/login.html#/login'},
    ],
  },
  {
    title: 'SERVICE',
    links: [
      {label: 'PRIVACY POLICY', path: '/index.html#/trsPrivacyPolicy'},
      {label: 'RETURN POLICY', path: '/index.html#/trsReturnPolicy'},
      {label: 'SHIPPING POLICY', path: '/index.html#/trsShippingPolicy'},
      {label: 'TERMS OF SERVICE', path: '/index.html#/trsTermsService'},
    ],
  },
  {
    title: 'ABOUT US',
    links: [
      {label: 'ABOUT TARAZON', path: '/index.html#/trsAboutTalison'},
      {label: 'CONTACT', path: '/index.html#/trsContact'},
    ],
  },
];

export default {
  name: 'trsFooter',
  props: {
    footerLogo: { // 是否展示品牌卖点区域
      type: Boolean,
      default: true
    },
    footerTheme: { // 底部背景主题，dark 深色 / light 浅色
      type: String,
      default: 'dark'
    }
  },
  data() {
    return {
      describeList: DESCRIBE_LIST,
      followList: FOLLOW_LIST,
    };
  },
  computed: {
    // 底部导航分组及链接
    navSections() {
      return FOOTER_NAV_CONFIG.map((section) => ({
        title: section.title,
        links: section.links.map((link) => ({
          label: link.label,
          href: this.getShoppingHref(link.path),
        })),
      }));
    },
    // 阿里巴巴分销商不展示商城底部
    isAlibabaDistributor() {
      return isAlibabaDistributor();
    },
    // 站点底部配置（备案号、底部文案等）
    footerInfo() {
      return commonLocalStorage.getItem('pageConfig') || this.$store.state.pageConfig;
    }
  },
  methods: {
    // 生成商城页完整跳转链接
    getShoppingHref(path) {
      return getHrefPath(path, SHOPPING_SERVICE);
    },
  },
};
</script>

<style lang="less" scoped>
@import "src/assets/styles/shopping/common";

.footer-box {
  width: 100%;
  background: #E7E8ED;

  .footer_describe {
    background-color: #fff;
    width: 100%;
    display: flex;
    justify-content: center;

    .footer_describe_content {
      width: 1200px;
      display: flex;
      height: 120px;
      justify-content: space-between;
      align-items: center;

      .footer_describe_item {
        display: flex;
        justify-content: center;
        width: 245px;
        height: 100%;
        align-items: center;

        .describe_conter {
          flex: 1;
          margin-left: 13px;

          .describe_title {
            font-family: SourceHanSansSC-Bold;
            font-size: 17px;
            font-weight: bold;
            font-stretch: normal;
            line-height: 22px;
            letter-spacing: 0px;
            color: #000000;
          }

          .describe_txt {
            font-family: SourceHanSansSC-Regular;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 18px;
            letter-spacing: 0px;
            color: #333333;
          }
        }
      }
    }
  }

  .footer-info-box {
    &.dark {
      background-color: #272B2E;

      .nav-item-title {
        color: #FFFFFF;
      }
    }

    &.light {
      background-color: #fff;

      .nav-item-title {
        color: #000;
      }
    }

    .footer-info-content {
      width: 1200px;
      margin: 0 auto;

      .footer-nav {
        display: flex;
        justify-content: space-between;
        padding-top: 30px;
        padding-bottom: 40px;

        .nav-item {
          width: 190px;
          text-align: left;

          .nav-item-title {
            font-size: 16px;
            margin-bottom: 14px;
          }

          .nav-item-menu {
            padding: 2px 0;
            font-size: 14px;
            cursor: pointer;
            color: #a2a4a5;

            a {
              color: #a2a4a5;
            }

            a:hover {
              color: #6EAF39;
            }
          }
        }
      }

      .keep-on-record {
        border-top: 1px solid #585A5B;
        padding: 24px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #A2A4A5;

        span {
          padding: 0 5px;
        }

        a {
          color: #A2A4A5;

          &:hover {
            color: #6EAF39;
          }
        }
      }
    }
  }
}
</style>
